import { del, get, post, put } from '@api/request';

export const fetchAllTaxingUnitGroups = async (
  { assessmentService },
  authenticationToken,
) => {
  const url = `${assessmentService}/assessment/taxingunitgroups`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const fetchTaxingUnitGroup = async (
  { assessmentService },
  authenticationToken,
  { groupID },
) => {
  const url = `${assessmentService}/assessment/taxingunitgroup/${groupID}`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const insertTaxingUnitGroup = async (
  { assessmentService },
  authenticationToken,
  { payload },
) => {
  const url = `${assessmentService}/assessment/taxingunitgroups`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
};

export const updateTaxingUnitGroup = async (
  { assessmentService },
  authenticationToken,
  { payload, groupID },
) => {
  const url = `${assessmentService}/assessment/taxingunitgroup/${groupID}`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
};

export const deleteTaxingUnitGroup = async (
  { assessmentService },
  authenticationToken,
  { groupID },
) => {
  const url = `${assessmentService}/assessment/taxingunitgroup/${groupID}`;
  const { body } = await del(authenticationToken, url);
  return body;
};

export const fetchTaxingUnitList = async (
  { assessmentService },
  authenticationToken,
) => {
  const url = `${assessmentService}/assessment/taxingunitlist`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const fetchGroupTaxingUnitList = async (
  { assessmentService },
  authenticationToken,
  { groupID },
) => {
  const url = `${assessmentService}/assessment/taxingunitgroup/${groupID}/taxingunits`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const insertTaxingUnit = async (
  { assessmentService },
  authenticationToken,
  { payload, groupID },
) => {
  const url = `${assessmentService}/assessment/taxingunitgroup/${groupID}/taxingunits`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
};

export const deleteTaxingUnit = async (
  { assessmentService },
  authenticationToken,
  { groupID },
) => {
  const url = `${assessmentService}/assessment/taxingunitgroup/taxingunit/${groupID}`;
  const { body } = await del(authenticationToken, url);
  return body;
};

export const updateTaxingUnitRequired = async (
  { assessmentService },
  authenticationToken,
  { groupID, payload },
) => {
  const url = `${assessmentService}/assessment/taxingunitgroup/taxingunit/${groupID}`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
};

export const fetchExemptionMappings = async (
  { assessmentService },
  authenticationToken,
) => {
  const url = `${assessmentService}/assessment/exemption/exemptionmappings`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const fetchExemptionTypes = async (
  { assessmentService },
  authenticationToken,
) => {
  const url = `${assessmentService}/assessment/exemption/exemptiontype`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const fetchExemptionApplyTo = async (
  { assessmentService },
  authenticationToken,
) => {
  const url = `${assessmentService}/assessment/exemption/applyto`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const createExemption = async (
  { assessmentService },
  authenticationToken,
  { year, payload },
) => {
  const url = `${assessmentService}/assessment/exemptions/${year}`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
};

export const updateExemption = async (
  { assessmentService },
  authenticationToken,
  { payload },
) => {
  const { exemptionCode, year } = payload;
  const url = `${assessmentService}/assessment/exemption/${exemptionCode}/${year}`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
};

export const deleteExemption = async (
  { assessmentService },
  authenticationToken,
  { payload: { exemptionCode, year } },
) => {
  const url = `${assessmentService}/assessment/exemption/${exemptionCode}/${year}`;
  const { body } = await del(authenticationToken, url);
  return body;
};
